import { render, staticRenderFns } from "./unitMaterialConsum.vue?vue&type=template&id=11874ffd&scoped=true"
import script from "./unitMaterialConsum.vue?vue&type=script&lang=js"
export * from "./unitMaterialConsum.vue?vue&type=script&lang=js"
import style0 from "./unitMaterialConsum.vue?vue&type=style&index=0&id=11874ffd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11874ffd",
  null
  
)

export default component.exports